import { flatMap, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  masterData: object;
  settingMasterData: object;
  DocumentMasterData: object;
  DropdownMasterData: object;
  DropdownMasterOptions: object;
  documentMasterEditData: object;
  SettingMasterEditData: object;
  error: string;
}

const initialArgs: Master = {
  masterData: {},
  settingMasterData: {},
  DocumentMasterData: {},
  DropdownMasterData: {},
  DropdownMasterOptions: {},
  documentMasterEditData: {},
  SettingMasterEditData: {},
  error: "",
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useSettingMaster = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getDocumentMaster = async () => {
    try {
      const result: any = await api.get(
        `/api/setting-category/type?slug=document`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DocumentMasterData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getSettingMaster = async (
    page: string,
    pageSize: string,
    searchText: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/setting-slug?page=${page}&pageSize=${pageSize}&searchValue=${searchText}&sort=${sort}&order=${order}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          settingMasterData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getDropdownMaster = async (
    page: string,
    pageSize: string,
    searchText: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/setting?page=${page}&pageSize=${pageSize}&searchValue=${searchText}&sort=${sort}&order=${order}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DropdownMasterData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getDropdownMasterOptions = async (type: string) => {
    try {
      const result: any = await api.get(
        `/api/setting-category/type?slug=${type}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DropdownMasterOptions: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const updateSettingMaster = async (param: any, dropdownid: any) => {
    const paramObj = {
      ...param,
    };
    console.log("dropdownid", dropdownid);

    console.log("paramObj => ", paramObj);

    try {
      const result: any = await api.put(
        `/api/setting-slug/${dropdownid}`,
        paramObj,
      );

      if (result.data.status) {
        // setState({ ...state, documentMasterEditData: result.data.data });
        toast.success("Setting Master Updated Successfully");
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const editSettingMatser = async (dropdownMasterId: string) => {
    console.log("dropdownMasterId => ", dropdownMasterId);

    try {
      const result: any = await api.get(`api/setting-slug/${dropdownMasterId}`);
      console.log(" result=> ", result.data.data);

      if (result.data.status) {
        setState({ ...state, SettingMasterEditData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const createSettingMaster = async (param: any) => {
    const paramObj = {
      ...param,
    };
    console.log("paramObj => ", paramObj);

    try {
      // const formData = new FormData();
      const result: any = await api.post("/api/setting-slug", paramObj);
      console.log("resultfromPostApi => ", result);

      if (result.data.status) {
        // toast.success(result.data.message);
        toast.success("Setting Master has been Added Successfully");
        setState({ ...state, masterData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  return {
    getDocumentMaster,
    getSettingMaster,
    getDropdownMaster,
    updateSettingMaster,
    getDropdownMasterOptions,
    editSettingMatser,
    createSettingMaster,
    ...state,
  };
};

export default useSettingMaster;
